module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-google-tagmanager/gatsby-browser.js'),
      options: {"plugins":[],"id":"GTM-K2VMR5M","includeInDevelopment":false,"routeChangeEventName":"Pageview"},
    }]
